import { render, staticRenderFns } from "./jumlahSingle.vue?vue&type=template&id=942e3ff4&scoped=true&"
import script from "./jumlahSingle.vue?vue&type=script&lang=js&"
export * from "./jumlahSingle.vue?vue&type=script&lang=js&"
import style0 from "./jumlahSingle.vue?vue&type=style&index=0&id=942e3ff4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942e3ff4",
  null
  
)

export default component.exports